import React from 'react'
import BackgroundGreyBox from '../svgs/GreyBox'
import BackgroundYellowBox from '../svgs/YellowBox'

interface Props {
  className?: string
}

const GreyBoxYellowBoxSwitcheroo: React.FunctionComponent<Props> = ({ className, children }) => {
  return (
    <div className={`switcheroo-box relative ${className ? className: ''}`}>
      <BackgroundGreyBox />
      <BackgroundYellowBox />
      {children}
    </div>
  )
}

export default GreyBoxYellowBoxSwitcheroo